import styled from "styled-components";

interface GridListProps {
  gridGap: number;
  columns: string;
}

const List = styled.ul<GridListProps>`
  display: grid;
  grid-gap: ${({ gridGap }) => gridGap}px;
  grid-template-columns: ${({ columns }) => columns};
  width: 100%;
  height: auto;
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-inline-start: 0em;
  margin-inline-end: 0em;
  padding-inline-start: 0em;
`;

interface ContainerProps {
  margin: number;
}

const Container = styled.nav<ContainerProps>`
  width: 100%;
  height: auto;
  margin: auto;
  margin-top: ${({ margin }) => margin}px;
  overflow: hidden;
`;

export default List;
export { List, Container };
